import {
	ICreateRoleHierarchyRequestData,
	ICreateUserRoleRequestData,
	IEditRoleHierarchyRequestData,
	IEditUserRoleRequestData,
	IGetUserGroupHierarchyResponseData,
	IGetUserRolesRequestData,
	IGetUserRolesResponse
} from "../../types";
import { getAPIHeaderOptions, transformErrorResponse } from "../../utils/apiUtils";
import { queries } from "./queries.reducer";

const rolesPermissions = queries.injectEndpoints({
	endpoints: (builder) => ({
		// GET USER ROLES
		getUserRoles: builder.query<IGetUserRolesResponse[], IGetUserRolesRequestData>({
			query: (requestData) => ({
				url: "/auth/rbac/groups/",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET USER GROUP HIERARCHY
		getUserGroupHierarchy: builder.query<IGetUserGroupHierarchyResponseData[], void>({
			query: () => ({
				url: "/auth/rbac/GroupHierarchyViewSet/",
				headers: getAPIHeaderOptions(true),
				method: "GET"
			})
		}),

		// CREATE USER ROLE
		createUserRole: builder.mutation<IGetUserRolesResponse, ICreateUserRoleRequestData>({
			query: (requestData) => ({
				url: "/auth/rbac/groups/",
				headers: getAPIHeaderOptions(true),
				method: "POST",
				body: requestData
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// EDIT USER ROLE
		editUserRole: builder.mutation<IGetUserRolesResponse, IEditUserRoleRequestData>({
			query: (requestData) => ({
				url: `/auth/rbac/groups/${requestData.id}/`,
				headers: getAPIHeaderOptions(true),
				method: "PATCH",
				body: requestData.data
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// CREATE ROLE HIERARCHY
		createRoleHierarchy: builder.mutation<IGetUserGroupHierarchyResponseData, ICreateRoleHierarchyRequestData>({
			query: (requestData) => ({
				url: "/auth/rbac/GroupHierarchyViewSet/",
				headers: getAPIHeaderOptions(true),
				method: "POST",
				body: requestData
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// EDIT ROLE HIERARCHY
		editRoleHierarchy: builder.mutation<IGetUserGroupHierarchyResponseData, IEditRoleHierarchyRequestData>({
			query: (requestData) => ({
				url: `/auth/rbac/GroupHierarchyViewSet/${requestData.id}/`,
				headers: getAPIHeaderOptions(true),
				method: "PATCH",
				body: requestData.data
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// DELETE USER ROLE
		deleteUserRole: builder.mutation<unknown, number>({
			query: (id) => ({
				url: `/auth/rbac/groups/${id}/`,
				headers: getAPIHeaderOptions(true),
				method: "DELETE"
			}),
			transformErrorResponse: transformErrorResponse
		})
	})
});

export const {
	// GET USER ROLES
	useGetUserRolesQuery,
	// GET USER GROUP HIERARCHY
	useGetUserGroupHierarchyQuery,
	// CREATE USER ROLE
	useCreateUserRoleMutation,
	// EDIT USER ROLE
	useEditUserRoleMutation,
	// CREATE ROLE HIERARCHY
	useCreateRoleHierarchyMutation,
	// EDIT ROLE HIERARCHY
	useEditRoleHierarchyMutation,
	// DELETE USER ROLE
	useDeleteUserRoleMutation
} = rolesPermissions;
